import { UpdateAnimatedParentElements, UpdateAnimatedChildElements } from './Animations/Animations.js';
 

window.addEventListener('scroll', function(e) {
    UpdateAnimatedChildElements();
    UpdateAnimatedParentElements();
}); 